module.exports = __webpack_public_path__ + "img/burritos.98ad96e5.jpg";